import React from 'react';
import { Icon } from './Icon.js';
export const IconLocation4Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m9,3c0-1.654-1.346-3-3-3s-3,1.346-3,3c0,1.394.96,2.558,2.25,2.893v2.857c0,.414.336.75.75.75s.75-.336.75-.75v-2.857c1.29-.335,2.25-1.5,2.25-2.893Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m10.75,12H1.25c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h9.5c.414,0,.75.336.75.75s-.336.75-.75.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLocation4Fill12.js.map